import { Component, Input, Output, EventEmitter, inject, OnInit, OnChanges, SimpleChanges, AfterViewInit, signal } from '@angular/core';
import { FormGroup, FormArray, Validators, FormBuilder, ReactiveFormsModule } from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { CommonModule, formatDate } from '@angular/common';
import { MatInputModule } from '@angular/material/input';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatDivider } from '@angular/material/divider';
import { MatSelectModule } from '@angular/material/select';
import { MatDatepicker, MatDatepickerModule } from '@angular/material/datepicker';
import { MatIcon } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import moment, { Moment } from 'moment';
import { provideMomentDateAdapter } from '@angular/material-moment-adapter';
import { allQualifications } from '../../new-rep-application-interfaces/qualifications.interface';
import { ViewNewRepApplication } from '../../new-rep-application-interfaces/viewnew-rep-application.interface';
import { viewAttachements } from '../../new-rep-application-interfaces/attachements.interface';
import { NewRepApplicationService } from '../../new-rep-application-services/new-rep-application.service';
import { MatDialog } from '@angular/material/dialog';
import { ConfirmPopupComponent } from '../../confirm-popup/confirm-popup.component';
import { SnackbarService } from '../../../../../shared/services/snackbar/snackbar.service';
import { HttpStatusCode } from 'axios';
import { SessionStorageService } from '../../../../../core/services/session-storage/session-storage.service';
import { RegulatoryProfessionalQualificationsService } from './regulatory-professional-qualifications-service/regulatory-professional-qualifications.service';
import { Router } from '@angular/router';
import { ProfessionalDetails, RegulatoryProfessionalQualifications } from './regulatory-professional-qualifications-interface/regulatory-professional-qualifications.interface';
import { RegulatoryProfessionalQualificationsModel } from './regulatory-professional-qualifications-models/regulatory-professional-qualifications.models';
import { noWhitespace } from '../../../../../shared/validators/no-whitespace.validator';
import { MonthYearDateFormatDirective } from '../../../../../shared/directives/month-year-date-format/month-year-date-format.directive';


export const MY_FORMATS = {
  parse: {
    dateInput: 'DD/MM/YYYY',
  },
  display: {
    dateInput: 'DD/MM/YYYY',
    monthYearLabel: 'MMM YYYY',
    dateA11yLabel: 'DD/MM/YYYY',
    monthYearA11yLabel: 'MMMM YYYY',
  },
};
@Component({
  selector: 'app-regulatory-professional-qualifications',
  standalone: true,
  providers: [
    provideMomentDateAdapter(MY_FORMATS)
  ],
  imports: [
    ReactiveFormsModule,
    MatInputModule,
    MatFormFieldModule,
    CommonModule,
    MatCheckboxModule,
    MatDivider,
    MatSelectModule,
    MatDatepickerModule,
    MatIcon,
    MatButtonModule,
    MonthYearDateFormatDirective
  ],
  templateUrl: './regulatory-professional-qualifications.component.html',
  styleUrl: './regulatory-professional-qualifications.component.scss'
})
export class RegulatoryProfessionalQualificationsComponent implements OnInit {
  @Output() next = new EventEmitter<string[]>();
  @Input() controlName: string = 'professionalqualifications';
  @Input() formGroup!: FormGroup;
  @Input() professionalqualifications!: allQualifications[];
  @Input() documentsresponse!: ViewNewRepApplication;
  @Input() viewattachments!: viewAttachements[];
  @Input() readonly = signal(false);
  @Output() preview = new EventEmitter<string[]>();
  @Output() save = new EventEmitter<string>();

  private fb = inject(FormBuilder);
  private readonly matDialog = inject(MatDialog);
  private newRepApplicationService = inject(NewRepApplicationService);
  private sessionStorageService = inject(SessionStorageService);
  private snackBarService = inject(SnackbarService);
  private regulatoryService = inject(RegulatoryProfessionalQualificationsService);
  private formArraySub?: any;
  private statusSub?: any;
  private router = inject(Router);
  setSprinner = signal(false);
  readonly message = 'This field is required.';
  status = 'Not Started';
  data = history.state;

  dateValue: moment.Moment | null = null;

  monthValue: moment.Moment | null = null;

  cmfasList = [
    { label: 'M5/RES5', control: 'm5' },
    { label: 'M9', control: 'm9' },
    { label: 'M8', control: 'm8' },
    { label: 'BCP', control: 'bcp' },
    { label: 'CM-EIP / M6', control: 'm6' },
    { label: 'M9A', control: 'm9a' },
    { label: 'M8A', control: 'm8a' },
    { label: 'PGI', control: 'pgi' },
    { label: 'CM-SIP / M6A', control: 'm6a' },
    { label: 'CM-LIP', control: 'lip' },
    { label: 'CM-CIS', control: 'cis' },
    { label: 'CommGI', control: 'commgi' },
    { label: 'CM-CMP', control: 'cmp' },
    { label: 'HI', control: 'hi' },
    { label: 'CM-LIC', control: 'lic' },
    { label: 'Certificate in GI', control: 'gi' }
  ];

  role = "";
  isVisible = signal(false)

  async ngOnInit() {

    // ✅ Add CMFAS controls dynamically
    this.cmfasList.forEach(item => {
      if (!this.formGroup.get(item.control)) {
        this.formGroup.addControl(item.control, this.fb.control('', [Validators.required]));
      }
    });


    // ✅ Add FormArray
    if (!this.formGroup.get(this.controlName)) {
      this.formGroup.addControl(this.controlName, this.fb.array([]));
    }

    // ✅ Ensure at least one row
    if (this.formArray.length === 0) {
      this.addRow();
    }

    // FIXUnsubscribe from any previous subscription before creating a new one.
    // to run repeatedly and the UI to lag/freeze on repeated reopen.
    this.formArraySub?.unsubscribe();
    this.formArraySub = (this.formGroup.get(this.controlName) as FormArray).valueChanges.subscribe(() => {
      this.checkFormArray();
    });

    this.role = this.sessionStorageService.getCurrentUserRole();
    if (this.role === 'DSU' || this.role === 'DSU Manager') {
      this.isVisible.set(true);
    }

    if (this.data?.applicant?.repcode) {
      await this.loadLicensing();
    } else {
      await this.fetchData();
    }

    this.handleFormStatus();
  }

  //get
  async loadLicensing(): Promise<void> {

    const request = {
      pias_rep_code: this.data.applicant.repcode,
      updated_by_role: ["Director", "Manager", "NEWREP", "DSU", "DSU Manager"]
    };

    const responseData = await this.regulatoryService
      .getLicensing(request)
      .then((response) => {
        return JSON.parse(response);
      })
      .catch((error) => {
        return error;
      });
    this.setSprinner.set(false);

    if (responseData.status === HttpStatusCode.Ok) {
      this.documentsresponse = responseData.data.responsedata.qualifications;
      this.professionalqualifications = responseData.data.responsedata.professional_details;
      this.viewattachments = responseData.data.responsedata.documents;
      this.fetchData();
    } else {
      if (responseData.code === HttpStatusCode.BadRequest) {
        // Display notification on API failure.
        this.snackBarService.openFailureSnackBar("We couldn’t process your request. Please try again");
      }
      if (responseData.code === HttpStatusCode.Unauthorized) {
        this.snackBarService.openFailureSnackBar("Session timed out. Try logging in again!");
        this.router.navigate(['/login']);
      }
    }

  }
  // Upload files for all CMFAS
  uploadedFiles: {
    [key: string]: {
      file?: File;
      name: string;
      isExisting: boolean;
    };
  } = {};

  async onFileChange(event: any, controlName: string, label: string) {
    const file = event.target.files[0];
    const fileControl = this.formGroup.get(controlName + '_file');

    if (file) {
      // Store file for preview
      this.uploadedFiles[controlName] = {
        file: file,
        name: file.name,
        isExisting: false
      };

      // Set to form control
      this.formGroup.get(controlName + '_file')?.setValue(file);
    }
    if (!file) {
      fileControl?.setValue(null);
      return;
    }

    const allowedTypes = ['application/pdf', 'image/jpeg', 'image/png'];
    const maxSize = 5 * 1024 * 1024; // 5MB

    // ❌ Invalid type
    if (!allowedTypes.includes(file.type)) {
      fileControl?.setErrors({ invalidType: true });
      return;
    }

    // ❌ Invalid size
    if (file.size > maxSize) {
      fileControl?.setErrors({ maxSize: true });
      return;
    }

    // ✅ Valid file
    fileControl?.setErrors(null);
    // fileControl?.setValue(file);
    const formData = new FormData();

    formData.append('file', file);
    formData.append('Description', label);
    formData.append('filename', file?.name);
    formData.append('ResponseValue', '');

    if (this.role === 'DSU' || this.role === 'DSU Manager') { formData.append('UserId', String(this.data.applicant.onboardingid)); }

    const responseData = await this.newRepApplicationService
      .uploadDocuments(formData)
      .then((response) => {
        return JSON.parse(response);
      })
      .catch((error) => {
        return error;
      });
    if (responseData.status === HttpStatusCode.Ok) {
      this.uploadedFiles[controlName] = {
        file: file,
        name: responseData.data.responsedata,
        isExisting: false
      };
      if (this.role === 'DSU' || this.role === 'DSU Manager') {
        this.viewDsuDocumants();
      } else {
        this.viewDocumants();
      }
      this.snackBarService.openSuccessSnackBar("document uploaded successfully!");
    } else {
      if (responseData.code === HttpStatusCode.BadRequest) {
        // Display notification on API failure.
        this.snackBarService.openFailureSnackBar("We couldn’t process your request. Please try again");
      }
    }
  }

  removecmfaFile(controlName: string, categoryname: string) {
    const dialogRef = this.matDialog.open(ConfirmPopupComponent, {
      width: '500px',
      disableClose: true,
      data: {
        message: 'Do you want to remove the attachement?',
        hidecancel: false,
      }
    });
    // REMOVED: this.viewDocumants(); — was firing before the user even
    // confirmed, and used the wrong (non-role-based) lookup.

    dialogRef.afterClosed().subscribe(async result => {
      if (result.data === true) {
        if (this.viewattachments) {
          let id;
          let docTypeId;
          let onboardingId;
          if (this.role === 'DSU' || this.role === 'DSU Manager') {
            this.viewattachments.forEach(item => {
              if (item?.onboardingDocumentType === categoryname && ['DSU', 'DSU Manager'].includes(item.updatedByRole)) {
                id = item.id,
                  docTypeId = item.docTypeId,
                  onboardingId = this.data.applicant.onboardingid;
              }
            });


          }
          else {
            this.viewattachments.forEach(item => {
              if (item?.onboardingDocumentType === categoryname) {
                id = item.id,
                  docTypeId = item.docTypeId,
                  onboardingId = item.onboardingId
              }
            });
          }

          const data = {
            onboardingId: onboardingId,
            docTypeId: docTypeId,
            id: id
          }
          if (id) {
            const responseData = await this.newRepApplicationService
              .deletedocument(data)
              .then((response) => {
                return JSON.parse(response);
              })
              .catch((error) => {
                return error;
              });
          }

        }


        // 1. Remove file from storage (this removes preview)
        delete this.uploadedFiles[controlName];

        // 2. Reset form control
        this.formGroup.get(controlName + '_file')?.reset();
        this.formGroup.get(controlName + '_file')?.markAsTouched();

        // 3. Clear file input (important!)
        const fileInput = document.getElementById(controlName) as HTMLInputElement;
        if (fileInput) {
          fileInput.value = '';
        }

        //role-based refresh, after delete succeeds
        if (this.role === 'DSU' || this.role === 'DSU Manager') {
           await this.viewDsuDocumants();
        } else {
          await this.viewDocumants();
        }
      } else {
        // console.log('User cancelled');
      }
    });
  }

  uploadValidation(controlName: string) {
    const dropdownValue = this.formGroup.get(controlName)?.value;
    this.formGroup.addControl(controlName + '_file', this.fb.control('', [Validators.required]));
    this.formGroup.addControl(controlName + '_Date', this.fb.control('', [Validators.required]));
    const fileControl = this.formGroup.get(controlName + '_file');
    const dateControl = this.formGroup.get(controlName + '_Date');

    if (dropdownValue === 'yes') {
      fileControl?.setValidators([Validators.required]);
      dateControl?.setValidators([Validators.required]);
      this.formGroup.get(controlName + '_file')?.markAsTouched();
      this.formGroup.get(controlName + '_Date')?.markAsTouched();
    } else {
      delete this.uploadedFiles[controlName];
      fileControl?.clearValidators();
      fileControl?.setValue(null);
      dateControl?.clearValidators();
      dateControl?.setValue(null);
      fileControl?.setErrors(null);
    }

    fileControl?.updateValueAndValidity();
    dateControl?.updateValueAndValidity();
  }


  //  Remove row (keep at least one row)
  async deleteRow(index: number): Promise<void> {
    const dialogRef = this.matDialog.open(ConfirmPopupComponent, {
      width: '500px',
      disableClose: true,
      data: {
        message: 'Do you want to delete the Qualification?',
        hidecancel: false,
      }
    });

    dialogRef.afterClosed().subscribe(async result => {
      if (result.data === true) {
        if (this.formArray.length > 1) {
          if (this.professionalqualifications[index]?.id != undefined) {
            let id = this.professionalqualifications[index]?.id;

            const responseData = await this.newRepApplicationService
              .deleteQualification(id)
              .then((response) => {
                return JSON.parse(response);
              })
              .catch((error) => {
                // console.error(error);
                return error;
              });
          }

          // Delete this row's attachment(s) too — deleteQualification doesn't remove them
          const attachments = (this.viewattachments ?? []).filter(item =>
            item?.onboardingDocumentType === 'Professional_Qualification' && index === Number(item?.responseValue)
          );
          for (const item of attachments) {
            const data = {
              onboardingId: item.onboardingId ?? this.data.applicant.onboardingid,
              docTypeId: item.docTypeId,
              id: item.id
            };
            await this.newRepApplicationService
              .deletedocument(data)
              .then((response) => {
                return JSON.parse(response);
              })
              .catch((error) => {
                return error;
              });
          }

          this.formArray.removeAt(index);

          if (attachments.length) {
            if (this.role === 'DSU' || this.role === 'DSU Manager') {
              this.viewDsuDocumants;
              this.viewDsuDocumants();
            } else {
              this.viewDocumants();
            }
          }
        } else {
          // optional: reset instead of delete last row
          this.formArray.at(0).reset();
        }
      } else {
        // console.log('User cancelled');
      }
    });
  }
  // ✅ Strongly typed FormArray
  get formArray(): FormArray<FormGroup> {
    return this.formGroup.get(this.controlName) as FormArray<FormGroup>;
  }

  // ✅ FIXED: use files + fileNames (array)
  createRow(): FormGroup {
    return this.fb.group({
      dateofAttainment: [''],
      professionalQualification: ['', noWhitespace],
      professionalbody: ['', noWhitespace],
      file: [null],
      fileName: [''],
    });
  }

  // ✅ Add row
  addRow(): void {
    this.formArray.push(this.createRow());
  }

  fetchData(): void {
    this.formGroup.controls['m5']?.setValue(['no', 'E', ''].includes(this.documentsresponse?.m5Res5) ? this.documentsresponse?.m5Res5 : 'yes');
    this.formGroup.controls['m9']?.setValue(['no', 'E', ''].includes(this.documentsresponse?.m9) ? this.documentsresponse?.m9 : 'yes');
    this.formGroup.controls['m8']?.setValue(['no', 'E', ''].includes(this.documentsresponse?.m8Rep) ? this.documentsresponse?.m8Rep : 'yes');
    this.formGroup.controls['bcp']?.setValue(['no', 'E', ''].includes(this.documentsresponse?.bcp) ? this.documentsresponse?.bcp : 'yes');
    this.formGroup.controls['m6']?.setValue(['no', 'E', ''].includes(this.documentsresponse?.m6Rep) ? this.documentsresponse?.m6Rep : 'yes');
    this.formGroup.controls['m9a']?.setValue(['no', 'E', ''].includes(this.documentsresponse?.m9a) ? this.documentsresponse?.m9a : 'yes');
    this.formGroup.controls['m8a']?.setValue(['no', 'E', ''].includes(this.documentsresponse?.m8aRep) ? this.documentsresponse?.m8aRep : 'yes');
    this.formGroup.controls['pgi']?.setValue(['no', 'E', ''].includes(this.documentsresponse?.pgi) ? this.documentsresponse?.pgi : 'yes');
    this.formGroup.controls['m6a']?.setValue(['no', 'E', ''].includes(this.documentsresponse?.m6aRep) ? this.documentsresponse?.m6aRep : 'yes');
    this.formGroup.controls['lip']?.setValue(['no', 'E', ''].includes(this.documentsresponse?.cmLip) ? this.documentsresponse?.cmLip : 'yes');
    this.formGroup.controls['cis']?.setValue(['no', 'E', ''].includes(this.documentsresponse?.cmCis) ? this.documentsresponse?.cmCis : 'yes');
    this.formGroup.controls['commgi']?.setValue(['no', 'E', ''].includes(this.documentsresponse?.commgi) ? this.documentsresponse?.commgi : 'yes');
    this.formGroup.controls['cmp']?.setValue(['no', 'E', ''].includes(this.documentsresponse?.cmCmp) ? this.documentsresponse?.cmCmp : 'yes');
    this.formGroup.controls['hi']?.setValue(['no', 'E', ''].includes(this.documentsresponse?.hi) ? this.documentsresponse?.hi : 'yes');
    this.formGroup.controls['lic']?.setValue(['no', 'E', ''].includes(this.documentsresponse?.cmLic) ? this.documentsresponse?.cmLic : 'yes');
    this.formGroup.controls['gi']?.setValue(['no', 'E', ''].includes(this.documentsresponse?.certInGi) ? this.documentsresponse?.certInGi : 'yes');

    this.viewattachments.forEach(item => {
      if (this.formGroup.get('m5')?.value == 'yes') {
        this.uploadValidation('m5');
        if (item?.onboardingDocumentType === 'M5/RES5') {
          this.setExistingFile('m5', item.fileName);


        }
        this.formGroup.controls['m5_Date']?.setValue(this.documentsresponse?.m5Res5);


      }
      if (this.formGroup.get('m9')?.value == 'yes') {
        this.uploadValidation('m9');
        if (item?.onboardingDocumentType === 'M9') {
          this.setExistingFile('m9', item.fileName);


        }
        this.formGroup.controls['m9_Date']?.setValue(this.documentsresponse?.m9);


      }
      if (this.formGroup.get('m8')?.value == 'yes') {
        this.uploadValidation('m8');
        if (item?.onboardingDocumentType === 'M8') {
          this.setExistingFile('m8', item.fileName);

        }
        this.formGroup.controls['m8_Date']?.setValue(this.documentsresponse?.m8Rep);

      }
      if (this.formGroup.get('bcp')?.value == 'yes') {
        this.uploadValidation('bcp');
        if (item?.onboardingDocumentType === 'BCP') {
          this.setExistingFile('bcp', item.fileName);

        }
        this.formGroup.controls['bcp_Date']?.setValue(this.documentsresponse?.bcp);

      }
      if (this.formGroup.get('m6')?.value == 'yes') {
        this.uploadValidation('m6');
        if (item?.onboardingDocumentType === 'CM-EIP / M6') {
          this.setExistingFile('m6', item.fileName);

        }
        this.formGroup.controls['m6_Date']?.setValue(this.documentsresponse?.m6Rep);


      }
      if (this.formGroup.get('m9a')?.value == 'yes') {
        this.uploadValidation('m9a');
        if (item?.onboardingDocumentType === 'M9A') {
          this.setExistingFile('m9a', item.fileName);

        }
        this.formGroup.controls['m9a_Date']?.setValue(this.documentsresponse?.m9a);

      }
      if (this.formGroup.get('m8a')?.value == 'yes') {
        this.uploadValidation('m8a');
        if (item?.onboardingDocumentType === 'M8A') {
          this.setExistingFile('m8a', item.fileName);

        }
        this.formGroup.controls['m8a_Date']?.setValue(this.documentsresponse?.m8aRep)

      }
      if (this.formGroup.get('pgi')?.value == 'yes') {
        this.uploadValidation('pgi');
        if (item?.onboardingDocumentType === 'PGI') {
          this.setExistingFile('pgi', item.fileName);


        }
        this.formGroup.controls['pgi_Date']?.setValue(this.documentsresponse?.pgi);


      }
      if (this.formGroup.get('m6a')?.value == 'yes') {
        this.uploadValidation('m6a');
        if (item?.onboardingDocumentType === 'CM-SIP / M6A') {
          this.setExistingFile('m6a', item.fileName);


        }
        this.formGroup.controls['m6a_Date']?.setValue(this.documentsresponse?.m6aRep);

      }
      if (this.formGroup.get('lip')?.value == 'yes') {
        this.uploadValidation('lip');
        if (item?.onboardingDocumentType === 'CM-LIP') {
          this.setExistingFile('lip', item.fileName);


        }
        this.formGroup.controls['lip_Date']?.setValue(this.documentsresponse?.cmLip);

      }
      if (this.formGroup.get('cis')?.value == 'yes') {
        this.uploadValidation('cis');
        if (item?.onboardingDocumentType === 'CM-CIS') {
          this.setExistingFile('cis', item.fileName);

        }
        this.formGroup.controls['cis_Date']?.setValue(this.documentsresponse?.cmCis);


      }
      if (this.formGroup.get('commgi')?.value == 'yes') {
        this.uploadValidation('commgi');
        if (item?.onboardingDocumentType === 'CommGI') {
          this.setExistingFile('commgi', item.fileName);

        }
        this.formGroup.controls['commgi_Date']?.setValue(this.documentsresponse?.commgi);


      }
      if (this.formGroup.get('cmp')?.value == 'yes') {
        this.uploadValidation('cmp');
        if (item?.onboardingDocumentType === 'CM-CMP') {
          this.setExistingFile('cmp', item.fileName);

        }
        this.formGroup.controls['cmp_Date']?.setValue(this.documentsresponse?.cmCmp);

      }
      if (this.formGroup.get('hi')?.value == 'yes') {
        this.uploadValidation('hi');
        if (item?.onboardingDocumentType === 'HI') {
          this.setExistingFile('hi', item.fileName);

        }
        this.formGroup.controls['hi_Date']?.setValue(this.documentsresponse?.hi);


      }
      if (this.formGroup.get('lic')?.value == 'yes') {
        this.uploadValidation('lic');
        if (item?.onboardingDocumentType === 'CM-LIC') {
          this.setExistingFile('lic', item.fileName);


        }
        this.formGroup.controls['lic_Date']?.setValue(this.documentsresponse?.cmLic);


      }
      if (this.formGroup.get('gi')?.value == 'yes') {
        this.uploadValidation('gi');
        if (item?.onboardingDocumentType === 'Certificate in GI') {
          this.setExistingFile('gi', item.fileName);

        }
        this.formGroup.controls['gi_Date']?.setValue(this.documentsresponse?.certInGi);


      }

    });

    const formArray = this.formGroup.get('professionalqualifications') as FormArray;

    // FClear existing rows before rebuilding to prevent row accumulation
    // on every fetchData() call (was causing rows to double each time section reloaded
    while (formArray.length) {
      formArray.removeAt(0);
    }

    this.professionalqualifications?.forEach((item, index) => {
      // if (index !== 0) {
      //   this.addRow();
      // }
      this.addRow();
      formArray.at(index).patchValue({
        dateofAttainment: item.attainmentDate,
        professionalQualification: item.professionalQualification,
        professionalbody: item.nameOfProfessionalBody,
      });
      this.viewattachments.forEach(item => {
        if (item?.onboardingDocumentType === 'Professional_Qualification' && index === Number(item?.responseValue)) {
          formArray.at(index).patchValue({
            fileName: item.fileName,
          })

        }
      });
    });

    //  FEnsure at least one row exists when professionalqualifications is empty/null
    if (this.formArray.length === 0) {
      this.addRow();
    }
    if (this.formGroup.valid) {
      const hasInvalidName = Object.values(this.uploadedFiles).every(
        file => !file.name?.trim()
      );
      if (hasInvalidName) {
        this.status = 'In Progress';
      } else {
        this.status = 'Completed';
      }
      this.next.emit([this.status, 'submitted']);
    } else if (this.formGroup.invalid) {
      const anyFilled = this.formArray.value.some((group: { [s: string]: unknown; } | ArrayLike<unknown>) =>
        Object.values(group).some(
          v => v && v.toString().trim() !== ''
        )
      );
      if (anyFilled) {
        this.status = 'In Progress';
        this.next.emit([this.status, 'submitted']);
      } else {
        this.status = 'Not Started';
        this.next.emit([this.status, 'submitted']);
      }
    }

    // Everything below is silent. It runs after the status was emitted above, so
    // any announcement here would reach the status watcher as a user edit and
    // downgrade a completed section to "In Progress" the moment it loaded.
    if (this.readonly() == true) {
      this.formGroup?.disable();
      this.formGroup?.get('file')?.disable();
      this.formGroup?.get('fileName')?.disable();

    } else {
      this.formGroup?.enable();
      this.formGroup?.get('file')?.enable();
      this.formGroup?.get('fileName')?.enable();
    }
  }

  setExistingFile(controlName: string, fileName: string) {
    // if (this.uploadedFiles[controlName]?.isExisting) return;
    const fileControl = this.formGroup.get(controlName + '_file');

    if (fileControl) {
      fileControl.setValue(fileName); // just display name
      fileControl.setErrors(null);
    }

    // Optional: store URL instead of file
    this.uploadedFiles[controlName] = {
      name: fileName,
      isExisting: true
    };
  }

  setdateofAttainment(normalizedMonthAndYear: Moment, datepicker: MatDatepicker<Moment>, index: number) {
    const control = this.formArray.at(index).get('dateofAttainment');
    const ctrlValue = moment(control?.value || new Date());
    ctrlValue.month(normalizedMonthAndYear.month());
    ctrlValue.year(normalizedMonthAndYear.year());
    control?.setValue(ctrlValue);
    datepicker.close();
  }

  setcertificateDate(normalizedMonthAndYear: Moment, datepicker: MatDatepicker<Moment>, controlname: string) {
    const control = this.formGroup.get(controlname);
    // const ctrlValue = moment(control?.value || new Date());
    const ctrlValue = moment(control?.value || new Date(), 'MM/YYYY');
    ctrlValue.month(normalizedMonthAndYear.month());
    ctrlValue.year(normalizedMonthAndYear.year());
    control?.setValue(ctrlValue);
    datepicker.close();
  }

  async onFileChange1(event: any, index: number): Promise<void> {
    const file = event.target.files?.[0];
    const fileControl = this.formArray.at(index).get('fileName');

    if (file) {
      this.formArray.at(index).patchValue({
        file: file,
        fileName: file.name
      });
    }
    if (!file) {
      fileControl?.setValue(null);
      return;
    }

    const allowedTypes = ['application/pdf', 'image/jpeg', 'image/png'];
    const maxSize = 5 * 1024 * 1024; // 5MB

    // ❌ Invalid type
    if (!allowedTypes.includes(file.type)) {
      fileControl?.setErrors({ invalidType: true });
      return;
    }

    // ❌ Invalid size
    if (file.size > maxSize) {
      fileControl?.setErrors({ maxSize: true });
      return;
    }

    // ✅ Valid file
    fileControl?.setErrors(null);
    // fileControl?.setValue(file);

    const formData = new FormData();

    formData.append('file', this.formArray.at(index).get('file')?.value);
    formData.append('Description', 'Professional_Qualification');
    formData.append('filename', this.formArray.at(index).get('file')?.value?.name);
    formData.append('ResponseValue', index.toString());

    if (this.role === 'DSU' || this.role === 'DSU Manager') { formData.append('UserId', String(this.data.applicant.onboardingid)); }

    const responseData = await this.newRepApplicationService
      .uploadDocuments(formData)
      .then((response) => {
        return JSON.parse(response);
      })
      .catch((error) => {
        return error;
      });
    if (responseData.status === HttpStatusCode.Ok) {
      this.formArray.at(index).patchValue({
        fileName: responseData.data.responsedata
      });

      if (this.role === 'DSU' || this.role === 'DSU Manager') {
        this.viewDsuDocumants();
      }
      else {
        this.viewDocumants();
      }

      this.snackBarService.openSuccessSnackBar("document uploaded successfully!");
    } else {
      if (responseData.code === HttpStatusCode.BadRequest) {
        // Display notification on API failure.
        this.snackBarService.openFailureSnackBar("We couldn’t process your request. Please try again");
      }
    }
  }

  async viewDocumants() {
    let id = Number(this.sessionStorageService.getCurrentUserId());
    const responseData = await this.newRepApplicationService
      .viewApplicationDetails(id)
      .then((response) => {
        return JSON.parse(response);
      })
      .catch((error) => {
        return error;
      });

    this.viewattachments = responseData.data.responsedata.attachments;
  }

  async viewDsuDocumants() {
    const request = {
      pias_rep_code: this.data.applicant.repcode,
      updated_by_role: ["Director", "Manager", "NEWREP", "DSU", "DSU Manager"]
    };
    const responseData = await this.regulatoryService
      .getLicensing(request)
      .then((response) => {
        return JSON.parse(response);
      })
      .catch((error) => {
        return error;
      });
    this.setSprinner.set(false);
    if (responseData.status === HttpStatusCode.Ok) {

      this.viewattachments =
        responseData.data.responsedata.documents;
    } else {
      if (responseData.code === HttpStatusCode.BadRequest) {
        // Display notification on API failure. 
        this.snackBarService.openFailureSnackBar("We couldn’t process your request. Please try again");
      }
      if (responseData.code === HttpStatusCode.Unauthorized) {
        this.snackBarService.openFailureSnackBar("Session timed out. Try logging in again!");
        this.router.navigate(['/login']);
      }
    }
  }

  removeFile(controlName: string, fileVar: string, index: number) {
    const dialogRef = this.matDialog.open(ConfirmPopupComponent, {
      width: '500px',
      disableClose: true,
      data: {
        message: 'Do you want to remove the attachement?',
        hidecancel: false,
      }
    });
    dialogRef.afterClosed().subscribe(async result => {
      if (result.data === true) {
        if (this.viewattachments) {
          let id;
          let docTypeId;
          let onboardingId;
          this.viewattachments.forEach(item => {
            if (item?.onboardingDocumentType === 'Professional_Qualification' && index === Number(item?.responseValue)) {
              id = item.id,
                docTypeId = item.docTypeId,
                onboardingId = item.onboardingId
            }
          });

          const data = {
            onboardingId: onboardingId,
            docTypeId: docTypeId,
            id: id
          }
          const responseData = await this.newRepApplicationService
            .deletedocument(data)
            .then((response) => {
              return JSON.parse(response);
            })
            .catch((error) => {
              return error;
            });
          this.formArray.at(index).get(controlName)?.reset();
          const fileInput = document.getElementById(controlName) as HTMLInputElement;
          if (fileInput) {
            fileInput.value = '';
          }
          this.formArray.at(index).get(fileVar)?.reset();
          this.formArray.at(index).get(controlName)?.markAsTouched();
          this.formArray.at(index).get(controlName)?.updateValueAndValidity();
        }
        // FMoved role-based refresh (viewDsuDocumants/viewDocumants) inside
        // the confirm block below — previously it fired before the user confirmed,
        // causing an unnecessary API call even on Cancel
        if (this.role === 'DSU' || this.role === 'DSU Manager') {
          this.viewDsuDocumants();
        }
        else {
          this.viewDocumants();
        }
      } else {
        // console.log('User cancelled');
      }
    });
  }

  isUploadRequired(): boolean {
    return this.cmfasList.some(item => {
      return this.formGroup.get(item.control)?.value === 'yes';
    });
  }
  getSelectedCmfas(): string[] {
    return this.cmfasList
      .filter(item => this.formGroup.get(item.control)?.value === 'yes')
      .map(item => item.label);
  }

  checkFormArray() {
    const formArray = this.formGroup.get(this.controlName) as FormArray;

    formArray.controls.forEach((group) => {

      const f1 = group.get('dateofAttainment');
      const f2 = group.get('professionalQualification');
      const f3 = group.get('professionalbody');
      const f4 = group.get('fileName');

      const hasAnyValue = !!(
        f1?.value ||
        f2?.value ||
        f3?.value ||
        f4?.value
      );

      const controls = [f1, f2, f3, f4];

      controls.forEach(control => {

        if (hasAnyValue) {

          if (control === f2 || control === f3) {
            control?.setValidators([
              Validators.required,
              noWhitespace
            ]);
          } else {
            control?.setValidators([
              Validators.required
            ]);
          }

          control?.markAsTouched();

        } else {
          control?.clearValidators();
        }

        control?.updateValueAndValidity({
          emitEvent: false
        });

      });

    });
  }

  handleFormStatus() {
    // Nothing in a read-only section can be a user edit - the form is disabled.
    // Every emission here is programmatic: the saved data being loaded, and
    // disable() itself, which empties formGroup.value so it can never match the
    // baseline below. Each one overwrote the status the section had just derived
    // from that data, leaving a completed application reading "In Progress".
    if (this.readonly()) return;

    const initialValue = this.formGroup.getRawValue();

    // this.formGroup.valueChanges.subscribe(currentValue => {
    //   const hasChanged =
    //     JSON.stringify(initialValue) !== JSON.stringify(currentValue);

    // FUnsubscribe from any previous subscription before creating a new one.
    // to fire repeatedly and the UI to lag/freeze on repeated reopen.
    this.statusSub?.unsubscribe();
    this.statusSub = this.formGroup.valueChanges.subscribe(currentValue => {
      const hasChanged =
        JSON.stringify(initialValue) !== JSON.stringify(currentValue);

      if (hasChanged) {
        this.status = 'In Progress';
        this.next.emit([this.status, 'change']);
      }
    });
  }

  //post
  async saveSection(): Promise<void> {

    // Run FormArray validation first
    this.checkFormArray();
    this.formGroup.markAllAsTouched();

    // Stop API call when validation fails
    if (this.formGroup.invalid) {
      this.snackBarService.openWarningSnackBar('Please resolve the highlighted fields before saving.');
      return;
    }
    //FPrevent duplicate save API calls if save is already in progress
    if (this.setSprinner()) {
      return;
    }

    this.setSprinner.set(true);

    const saveLicensing = new RegulatoryProfessionalQualificationsModel();

    const professionalDetails: ProfessionalDetails = {

      m5_res5: this.formGroup.get('m5')?.value == 'yes' ? formatDate(
        this.formGroup.get('m5_Date')?.value,
        'yyyy-MM-dd',
        'en-US'
      ) : this.formGroup.get('m5')?.value,
      m9: this.formGroup.get('m9')?.value == 'yes' ? formatDate(
        this.formGroup.get('m9_Date')?.value,
        'yyyy-MM-dd',
        'en-US'
      ) : this.formGroup.get('m9')?.value,
      m8_rep: this.formGroup.get('m8')?.value == 'yes' ? formatDate(
        this.formGroup.get('m8_Date')?.value,
        'yyyy-MM-dd',
        'en-US'

      ) : this.formGroup.get('m8')?.value,
      bcp: this.formGroup.get('bcp')?.value == 'yes' ? formatDate(
        this.formGroup.get('bcp_Date')?.value,
        'yyyy-MM-dd',
        'en-US'
      ) : this.formGroup.get('bcp')?.value,
      m6_rep: this.formGroup.get('m6')?.value == 'yes' ? formatDate(
        this.formGroup.get('m6_Date')?.value,
        'yyyy-MM-dd',
        'en-US'

      ) : this.formGroup.get('m6')?.value,
      m9a: this.formGroup.get('m9a')?.value == 'yes' ? formatDate(
        this.formGroup.get('m9a_Date')?.value,
        'yyyy-MM-dd',
        'en-US'
      ) : this.formGroup.get('m9a')?.value,
      m8a_rep: this.formGroup.get('m8a')?.value == 'yes' ? formatDate(
        this.formGroup.get('m8a_Date')?.value,
        'yyyy-MM-dd',
        'en-US'
      ) : this.formGroup.get('m8a')?.value,
      pgi: this.formGroup.get('pgi')?.value == 'yes' ? formatDate(
        this.formGroup.get('pgi_Date')?.value,
        'yyyy-MM-dd',
        'en-US'
      ) : this.formGroup.get('pgi')?.value,
      m6a_rep: this.formGroup.get('m6a')?.value == 'yes' ? formatDate(
        this.formGroup.get('m6a_Date')?.value,
        'yyyy-MM-dd',
        'en-US'

      ) : this.formGroup.get('m6a')?.value,
      cm_lip: this.formGroup.get('lip')?.value == 'yes' ? formatDate(
        this.formGroup.get('lip_Date')?.value,
        'yyyy-MM-dd',
        'en-US'

      ) : this.formGroup.get('lip')?.value,
      cm_cis: this.formGroup.get('cis')?.value == 'yes' ? formatDate(
        this.formGroup.get('cis_Date')?.value,
        'yyyy-MM-dd',
        'en-US'
      ) : this.formGroup.get('cis')?.value,
      commgi: this.formGroup.get('commgi')?.value == 'yes' ? formatDate(
        this.formGroup.get('commgi_Date')?.value,
        'yyyy-MM-dd',
        'en-US'

      ) : this.formGroup.get('commgi')?.value,
      cm_cmp: this.formGroup.get('cmp')?.value == 'yes' ? formatDate(
        this.formGroup.get('cmp_Date')?.value,
        'yyyy-MM-dd',
        'en-US'

      ) : this.formGroup.get('cmp')?.value,
      hi: this.formGroup.get('hi')?.value == 'yes' ? formatDate(
        this.formGroup.get('hi_Date')?.value,
        'yyyy-MM-dd',
        'en-US'

      ) : this.formGroup.get('hi')?.value,
      cm_lic: this.formGroup.get('lic')?.value == 'yes' ? formatDate(
        this.formGroup.get('lic_Date')?.value,
        'yyyy-MM-dd',
        'en-US'
      ) : this.formGroup.get('lic')?.value,
      cert_in_gi: this.formGroup.get('gi')?.value == 'yes' ? formatDate(
        this.formGroup.get('gi_Date')?.value,
        'yyyy-MM-dd',
        'en-US'
      ) : this.formGroup.get('gi')?.value


    };
    // Save API call or form validation here
    for (let i = this.formArray.length - 1; i >= 0; i--) {
      const group = this.formArray.at(i);

      const isEmpty =
        !group.get('professionalbody')?.value &&
        !group.get('professionalQualification')?.value &&
        !group.get('dateofAttainment')?.value &&
        !group.get('fileName')?.value;

      if (isEmpty && this.formArray.length > 1) {
        this.formArray.removeAt(i);
      }
    }


    for (let i = this.formArray.length - 1; i >= 0; i--) {
      const group = this.formArray.at(i);

      if (
        !group.get('professionalbody')?.value &&
        !group.get('professionalQualification')?.value &&
        !group.get('dateofAttainment')?.value &&
        !group.get('fileName')?.value
      ) {
        this.formArray.removeAt(i);
      }
    }

    const qualifications: RegulatoryProfessionalQualifications[] =
      this.formArray.controls.map((group, index) => ({
        id: this.professionalqualifications?.[index]?.id ?? 0,
        onboardingRepId: this.professionalqualifications?.[index]?.onboardingId ?? 0,
        category_name: 'PROFESSIONAL',
        qualification_type: 'PROFESSIONAL',
        name_of_professional_body: group.get('professionalbody')?.value,
        professional_qualification: group.get('professionalQualification')?.value,
        attainment_date: group.get('dateofAttainment')?.value ? formatDate(group.get('dateofAttainment')?.value, 'yyyy-MM', 'en-US') : '',
      }));

    saveLicensing.setPiasRepCode(this.data.applicant.repcode);
    saveLicensing.setProfessionalDetails(professionalDetails);
    saveLicensing.setQualifications(qualifications);

    const responseData = await this.regulatoryService
      .saveLicensingData(saveLicensing as any)
      .then((response) => JSON.parse(response))
      .catch((error) => error);

    this.setSprinner.set(false);

    if (responseData.status === HttpStatusCode.Ok) {

      //FReload latest data from backend so newly added/updated
      // qualification rows reflect immediately in the UI without manual refresh
      await this.loadLicensing();
      this.save.emit('saved');
    }
    else {

      if (responseData.code === HttpStatusCode.BadRequest) {
        this.snackBarService.openFailureSnackBar(
          "We couldn’t process your request. Please try again"
        );
      }

      if (responseData.code === HttpStatusCode.Unauthorized) {
        this.snackBarService.openFailureSnackBar(
          "Session timed out. Try logging in again!"
        );
        this.router.navigate(['/login']);
      }
    }
  }

  cancelSection(): void {
    this.save.emit('cancelled');
  }

  // ✅ Submit
  saveAndContinue() {
    // Save API call or form validation here
    for (let i = this.formArray.length - 1; i >= 0; i--) {
      const group = this.formArray.at(i);

      const isEmpty =
        !group.get('professionalbody')?.value &&
        !group.get('professionalQualification')?.value &&
        !group.get('dateofAttainment')?.value &&
        !group.get('fileName')?.value;

      if (isEmpty && this.formArray.length > 1) {
        this.formArray.removeAt(i);
      }
    }
    if (this.formGroup.valid) {
      this.status = 'Completed';

    }
    this.formGroup.markAllAsTouched();
    this.next.emit([this.status, 'submit']);

  }
  previewAttachment(controlName: string, index: number) {
    if (this.viewattachments) {
      let id;
      this.viewattachments.forEach(item => {
        if (item?.onboardingDocumentType === 'Professional_Qualification' && index === Number(item?.responseValue)) {
          id = item.id
        }
      });
      let filename = this.formArray.at(index).get(controlName)?.value;
      this.preview.emit([id, filename]);
    }
  }

  previewcmfaFileAttachment(controlName: string, categoryname: string) {
    let fileid: any;
    let filename: any;
    if (this.viewattachments) {
      this.viewattachments.forEach(item => {
        if (item?.onboardingDocumentType === categoryname) {
          fileid = item.id,
            filename = item.fileName
        }
      });
      this.preview.emit([fileid, filename]);

    }
  }
}